import TopBar from "./topbar/topbar";
import LineIndicator from "../../ui/lineindicator/lineindicator";
import {useLocation, useNavigate} from "react-router-dom"
import SocialMedia from "../../ui/socialmedia/socialmedia";
import "./header.scss";
import Button from "../../core/button/button";

const Header = () => {
    let location = useLocation();
    let navigate = useNavigate();
    const renderTitle = (url: string): JSX.Element => {
        if (url === "/about-us") {
            return (
                <div className="Page-Title">
                    <LineIndicator/>
                    <h3 className="Title">درباره ما</h3>
                </div>
            );
        } else if (url === "/contact-us") {
            return (
                <div className="d-flex justify-content-between align-items-center">
                    <div className="Page-Title">
                        <LineIndicator/>
                        <h3 className="Title">تماس با ما</h3>
                    </div>
                    <div style={{transform: 'translateY(-125%)'}}>
                        <SocialMedia theme={"Light"}/>
                    </div>
                </div>
            );
        } else if (url === "/articles") {
            return (
                <div className="Page-Title">
                    <LineIndicator/>
                    <h3 className="Title">آخرین مقالات ما</h3>
                </div>
            );
        } else if (url === "/") {
            return (
                <div className="Main-Page">
                    <div className="row" style={{paddingBottom: '100px'}}>
                        <div className="col-lg-6 col-12 mb-3">
                            <h1 className="Main-Title">تــیــجــــــار</h1>
                            <h3 className="Main-Subtitle">دستیار هوش مصنوعی تبلیغات شما</h3>
                            <p className="Main-Description">لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
                                است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است</p>
                            <div className="d-flex justify-content-start align-items-center gap-5">
                                <Button type={"secondary"} action={() => {
                                    navigate("/matching-campaign",{
                                        replace:false
                                    })
                                }} responsive={false} >میخوام شروع کنم</Button>
                                <div onClick={() => {
                                    navigate("/about-us",{
                                        replace:false
                                    })
                                }} className="d-flex justify-content-start align-items-center" style={{cursor: 'pointer'}}>
                                    <span className="dark-text pt-1">درباره تیجار</span>
                                    <img src={require("../../assets/images/icons/Play.svg").default} alt="" className="img-fluid" style={{transform: 'translateY(15px)'}}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 mt-3">
                            <img src={require("../../assets/images/photos/Main.png")} alt=""
                                 className="img-fluid Main-Image"/>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    }

    return (
        <div className="Header float-start">
            <div className="container">
                <TopBar/>
                {renderTitle(location.pathname)}
            </div>
        </div>
    );
}

export default Header;